<template>
    <div>
        <div class="popup_st21 w200" style="position:absolute; display:block;">
            <div :class="classPrefix + 'popup_wrap'">
                <div class="title"><span class="ict_btn blue">모기개체수</span> <span class="t01">{{ mediumMosqInfo.hjdNm }}</span></div>
                <div class="text"><span>({{ formatDate(mediumMosqInfo.measureTime) }} 기준)</span></div>

                <div class="pop_table02">
                    <table>
                        <caption></caption>
                        <colgroup>
                            <col style="width: 60%;">
                            <col style="width: 40%;">
                        </colgroup>
                        <thead>
                            <tr>
                                <th>종류</th>
                                <th>개체수</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <th>얼룩날개모기속</th>
                                <td>{{ !isNaN(mediumMosqInfo.dottedMos)? mediumMosqInfo.dottedMos : '-' }}</td>
                            </tr>
                            <tr>
                                <th>빨간집모기</th>
                                <td>{{ !isNaN(mediumMosqInfo.redMos)? mediumMosqInfo.redMos : '-' }}</td>
                            </tr>
                            <tr>
                                <th>금빛숲모기</th>
                                <td>{{ !isNaN(mediumMosqInfo.goldMos)? mediumMosqInfo.goldMos : '-' }}</td>
                            </tr>
                            <tr>
                                <th>흰줄숲모기</th>
                                <td>{{ !isNaN(mediumMosqInfo.whiteMos)? mediumMosqInfo.whiteMos : '-' }}</td>
                            </tr>
                            <tr>
                                <th>기타</th>
                                <td>{{ !isNaN(mediumMosqInfo.etcMos)? mediumMosqInfo.etcMos : '-' }}</td>
                            </tr>
                            <tr>
                                <th>계</th>
                                <td>{{ !isNaN(mediumMosqInfo.val)? mediumMosqInfo.val : '-' }}</td>
                            </tr>
                            <tr>
                                <th>모기활동지수</th>
                                <td>{{ !isNaN(mediumMosqInfo.mediumMosq)? mediumMosqInfo.mediumMosq : '-' }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div class="pop_bt_close2"><a href="javascript: void(0);" class="self-close-btn">닫기</a></div>
            </div>
        </div>
    </div>
</template>

<script>
import { $_TYPE } from '@/confs/common.const';
import {mapGetters} from "vuex";
import gripUtil from "@/libs/grip.util";
import airLevel from "@/libs/air.level.js";

export default {
    props: {
        classPrefix: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            mediumMosqInfo: {},
            measureTime: '',
        };
    },

    computed: {
    },

    updated() {
        if(typeof this.mediumMosqInfo.hjdNm !== $_TYPE.UNDEF) {
            this.$emit('loaded-medium-mosq-info', this.$el.innerHTML);
        }
    },

    methods: {
        setMediumMosqInfo(mediumMosqInfo) {
            this.measureTime = mediumMosqInfo.measureTime;
            this.mediumMosqInfo = Object.assign({}, mediumMosqInfo);
        },
        formatDate(measureTime) {
            let basdt = ''
            if(typeof measureTime !== 'undefined') {
                basdt = measureTime;

                let list = basdt.split(' ');
                basdt = list[0];
                if(basdt.substring(4,5) === '0') {
                    basdt = basdt.substring(5,6) + '월 '+ list[1]+ '주';
                } else {
                    basdt = basdt.substring(4,6) + '월 '+ list[1]+ '주';
                }
            }
            return basdt
        },
    },
}
</script>
<style>

</style>
